export interface Dimension {
  id: string;
  name: string;
  short: string;
  icon: string;
  desc: string;
}

export const dimensions: Dimension[] = [
  {
    id: 'details',
    name: '爆料背后细节',
    short: '背后细节',
    icon: 'ri-file-search-line',
    desc: '剔除情绪化转述，只保留能被反复核对的原始细节：谁先说的、在哪说的、原话怎么写的。',
  },
  {
    id: 'foreshadow',
    name: '被忽略的伏笔',
    short: '隐藏伏笔',
    icon: 'ri-eye-off-line',
    desc: '把此前被当作闲聊、口误、临时改动的碎片重新排进时间轴，看它们是否提前埋下了答案。',
  },
  {
    id: 'timeline',
    name: '时间线关键节点',
    short: '时间节点',
    icon: 'ri-time-line',
    desc: '以小时为单位还原节点顺序，标出真正改变走向的那几步，而不是被讨论最多的那几步。',
  },
  {
    id: 'connections',
    name: '事件隐藏关联',
    short: '隐藏关联',
    icon: 'ri-node-tree',
    desc: '把不同事件里反复出现的名字、时间、渠道连成图谱，找出被忽略的交汇点。',
  },
];